// 고객 화면(스냅샷)의 부가세 표기 한 곳 — 모바일·인쇄가 같은 숫자·문구를 쓴다.

import { storedSplitOf, VatMode } from "../money/vat";
import { SnapshotData, snapshotVatMode } from "./types";

export interface SnapshotVat {
  mode: VatMode;
  total: number;
  supply: number;
  vat: number;
}

// 총액은 늘 스냅샷 `total` — 나누기는 `storedSplitOf` 한 벌(별도 견적은 총액 = 공급가 + round(공급가÷10) 이라 총액에서 나눠도 공급가가 그대로 나온다).
export const snapshotVatOf = (data: Pick<SnapshotData, "quote">): SnapshotVat => {
  const split = storedSplitOf(data.quote);
  return { mode: snapshotVatMode(data), total: data.quote.total, supply: split.supply_amount, vat: split.vat_amount };
};

// 「단가에 부가세」 처럼 앞말이 이미 붙은 좁은 자리용 — 「포함」/「별도」.
export const vatModeShortLabel = (mode: VatMode): string => (mode === "EXCL" ? "별도" : "포함");

// 단가·금액이 어느 기준인지 한 줄 — 「부가세 포함」/「부가세 별도」.
export const vatBasisLabel = (mode: VatMode): string => `부가세 ${vatModeShortLabel(mode)}`;

// 총액 옆 꼬리표 — 총액은 늘 부가세 포함, 별도 견적이면 단가 기준만 덧붙인다.
export const totalVatNote = (mode: VatMode): string => (mode === "EXCL" ? `부가세 포함 · 단가 ${vatBasisLabel(mode)}` : "부가세 포함");

// 단가 머리글 — 「단가(부가세 포함)」/「단가(부가세 별도)」.
export const unitPriceHeading = (mode: VatMode): string => `단가(${vatBasisLabel(mode)})`;

export const TOTAL_LABEL = "최종 견적금액 (부가세 포함)";
// 가견적 총액 — 편집기·상세·인쇄가 같은 말을 쓴다(별도 가견적은 그 위에 공급가액·부가세 두 줄).
export const ROUGH_TOTAL_LABEL = "개산 금액 (부가세 포함)";
export const SUPPLY_LABEL = "공급가액";
export const VAT_LABEL = "부가세 (10%)";
export const INCL_SUPPLY_LABEL = "그중 공급가액";
export const INCL_VAT_LABEL = "그중 부가세";
